import "lazysizes";

import Swiper from "swiper";
import "swiper/css";
window.Swiper = Swiper;

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.start();

import { MarkerWithLabel } from "@googlemaps/markerwithlabel";
window.MarkerWithLabel = MarkerWithLabel;

import Headroom from "headroom.js";
const headerElement = document.getElementById("document-header");
if (headerElement) {
  const headroom = new Headroom(headerElement, {
     onNotTop : function() {
      const header = headerElement.querySelector('header');
      headerElement.dataset.headroomNotTop?.trim().split(' ').forEach(x => {
        header.classList.add(x)
      });
     },
     onTop: function() {
      const header = headerElement.querySelector('header');
      headerElement.dataset.headroomNotTop?.trim().split(' ').forEach(x => {
        header.classList.remove(x)
      });
     }
  });
  headroom.init();
}

import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";

window.enableBodyScroll = enableBodyScroll;
window.disableBodyScroll = disableBodyScroll;
window.clearAllBodyScrollLocks = clearAllBodyScrollLocks;

document.querySelectorAll(".fui-form").forEach((form) => {
  form.addEventListener("submit", (event) => {
    event.preventDefault();

    var submitButton = form.querySelector(".fui-btn");

    // Disable the button after a short delay
    setTimeout(() => {
      submitButton.disabled = true;
    }, 100);

    // Submit the form after a short delay
    setTimeout(() => {
      form.submit();
    }, 200);
  });
});

// document.querySelectorAll('a.anchor-link').forEach($anchor => {
//     $anchor.addEventListener('click', function (e) {
//         e.preventDefault();

//         document.querySelector(this.getAttribute('href')).scrollIntoView({
//             behavior: 'smooth',
//             block: 'start' //scroll to top of the target element
//         });
//     });
// });

document.addEventListener("onFormieInit", (e) => {
  const forms = e.detail.formie.forms;

  forms.forEach(function (f) {
    const form = f.$form;

    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton) return;

    form.addEventListener("submit", function () {
      submitButton.disabled = true;
      submitButton.classList.add("is-loading");
    });

    form.addEventListener("onAfterFormieSubmit", function (e) {
      e.preventDefault();

      submitButton.disabled = false;
      submitButton.classList.remove("is-loading");
    });

    form.addEventListener("onFormieSubmitError", function (e) {
      e.preventDefault();

      submitButton.disabled = false;
      submitButton.classList.remove("is-loading");
    });
  });
});
